import React from 'react';
import { Layout } from '../components/Layout';
import { Lock, Globe, Zap, Cpu, Check, Shield, Thermometer, Warehouse, Power, Network } from 'lucide-react';
import serverImage from '../assets/aigc/images/server-room_1768402418_000.png';

export const DataCenter: React.FC = () => {
  return (
    <Layout>
      <div className="pt-20">
        {/* Technical Specifications Section */}
        <section className="py-24 bg-white">
          <div className="container mx-auto px-6">
            <div className="text-center max-w-3xl mx-auto mb-16">
              <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">Helsinki DC Data Center - Tekniset tiedot</h2>
              <p className="text-slate-600 text-lg">
                Helsinki DC on suunniteltu täyttämään korkeimmat turvallisuus- ja käytettävyysvaatimukset.
                Sähkönsyötön varmistukset, tarkka ympäristön monitorointi ja palosammutusjärjestelmät varmistavat parhaan mahdollisen ympäristön palvelinlaittiestoille. Ylläpitäjille mahdollistamme myös pääsyn palvelinkeskukseen ympäri vuorokauden. Asiantuntijamme toteuttavat tarvittaessa palvelinlaitteistojenne huolto-ylläpitotöitä Remote Hands-palvelun avulla.
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-8">
              {/* Tilan tekniset tiedot */}
              <div className="bg-slate-50 p-8 rounded-2xl border border-slate-200 hover:shadow-lg transition-all">
                <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-6 text-blue-600">
                  <Warehouse className="w-6 h-6" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-6">Tilan tekniset tiedot</h3>
                <ul className="space-y-4">
                  {[
                    "Betonista rakennettu tila",
                    "Vapaa korkeus 3,0 metriä",
                    "Korotettu lattia",
                    "Paloturvalliset pintamateriaalit"
                  ].map((item, idx) => (
                    <li key={idx} className="flex items-start gap-3 text-slate-700">
                      <Check className="w-5 h-5 text-blue-500 flex-shrink-0 mt-0.5" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Ilmastointi ja jäähdytys */}
              <div className="bg-slate-50 p-8 rounded-2xl border border-slate-200 hover:shadow-lg transition-all">
                <div className="w-12 h-12 bg-emerald-100 rounded-xl flex items-center justify-center mb-6 text-emerald-600">
                  <Thermometer className="w-6 h-6" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-6">Ilmastointi ja jäähdytys</h3>
                <ul className="space-y-4">
                  {[
                    "Lämpötila 20 ±2 °C",
                    "Ylipaineistettu tila",
                    "Kahdennetut vakioilmastointikoneet (N+1 periaate)",
                    "Suljettu vesi- ja jäähdytysjärjestelmä"
                  ].map((item, idx) => (
                    <li key={idx} className="flex items-start gap-3 text-slate-700">
                      <Check className="w-5 h-5 text-emerald-500 flex-shrink-0 mt-0.5" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Turvallisuusjärjestelyt */}
              <div className="bg-slate-50 p-8 rounded-2xl border border-slate-200 hover:shadow-lg transition-all">
                <div className="w-12 h-12 bg-indigo-100 rounded-xl flex items-center justify-center mb-6 text-indigo-600">
                  <Shield className="w-6 h-6" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-6">Turvallisuusjärjestelyt</h3>
                <ul className="space-y-4">
                  {[
                    "Ympärivuorokautinen vartiointi",
                    "Tallentava kameravalvonta",
                    "Sähköinen kulunvalvonta",
                    "Turvallisuusportaali"
                  ].map((item, idx) => (
                    <li key={idx} className="flex items-start gap-3 text-slate-700">
                      <Check className="w-5 h-5 text-indigo-500 flex-shrink-0 mt-0.5" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            


<div style={{ height: '40px' }} />          {/* vertical empty space */}

            <div className="grid md:grid-cols-3 gap-8">
              {/* Sähkönsyöttö */}
              <div className="bg-slate-50 p-8 rounded-2xl border border-slate-200 hover:shadow-lg transition-all">
                <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-6 text-blue-600">
                  <Power className="w-6 h-6" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-6">Sähkönsyöttö</h3>
                <ul className="space-y-4">
                  {[
                    "Kahdennettu sähkönsyöttö (A+B)",
                    "Kahdennettu UPS-järjestelmä",
                    "Sähkö kulutuksen mukaan",
                    "Diesel-generaattorivarmistus"
                  ].map((item, idx) => (
                    <li key={idx} className="flex items-start gap-3 text-slate-700">
                      <Check className="w-5 h-5 text-blue-500 flex-shrink-0 mt-0.5" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Verkkoyhteydet */}
              <div className="bg-slate-50 p-8 rounded-2xl border border-slate-200 hover:shadow-lg transition-all">
                <div className="w-12 h-12 bg-emerald-100 rounded-xl flex items-center justify-center mb-6 text-emerald-600">
                  <Network className="w-6 h-6" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-6">Verkkoyhteydet</h3>
                <ul className="space-y-4">
                  {[
                    "Carrier neutral datacenter",
                    "Kahdennetut runkoreitittimet",
                    "Kahdenetut kuituyhteydet kiinteistöön",
                    "DWDM-yhteydet keskeisiin yhdysliikennepisteisiin",
                    
                  ].map((item, idx) => (
                    <li key={idx} className="flex items-start gap-3 text-slate-700">
                      <Check className="w-5 h-5 text-emerald-500 flex-shrink-0 mt-0.5" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Turvallisuusjärjestelyt */}
              <div className="bg-slate-50 p-8 rounded-2xl border border-slate-200 hover:shadow-lg transition-all">
                <div className="w-12 h-12 bg-indigo-100 rounded-xl flex items-center justify-center mb-6 text-indigo-600">
                  <Shield className="w-6 h-6" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-6">Ympäristön suojaus</h3>
                <ul className="space-y-4">
                  {[
                    "Ennakoiva VESDA-palosuojaus",
                    "Inergen-kaasusammutus",
                    "Ympäristön 24/7 monitorointi",
                    "Suojaus kosteusvahingoilta"
                  ].map((item, idx) => (
                    <li key={idx} className="flex items-start gap-3 text-slate-700">
                      <Check className="w-5 h-5 text-indigo-500 flex-shrink-0 mt-0.5" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          
          
        </section>

        <section className="py-24 bg-slate-900 text-white relative overflow-hidden">
          <div className="absolute inset-0 opacity-20">
            <img src={serverImage} alt="Server Room" className="w-full h-full object-cover" />
          </div>
          <div className="absolute inset-0 bg-slate-900/90" />
          
          <div className="container mx-auto px-6 relative z-10">
            <div className="text-center max-w-3xl mx-auto mb-16">
              <h1 className="text-4xl md:text-5xl font-bold mb-6">Teknistä varmuutta</h1>
              <p className="text-xl text-slate-300">
                Helsinki DC - Datacenter Pitäjänmäellä tarjoaa huippuluokan infrastruktuurin, joka on suunniteltu kriittisille työkuormille varmistaen maksimaalisen käyttöajan ja turvallisuuden.
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 text-center">
              {[
                { icon: <Lock />, label: "Ympärivuorokautinen valvonta", value: "24/7" },
                { icon: <Globe />, label: "Nopeat yhteydet", value: "100 Gbps+" },
                { icon: <Zap />, label: "Korkea käytettävyys", value: "99.999%" },
                { icon: <Cpu />, label: "Nopeat vasteajat kaikkiin suomalaisiin verkon solmupisteisiin", value: "1 ms" },
              ].map((stat, idx) => (
                <div key={idx} className="p-6 rounded-2xl bg-white/5 backdrop-blur-sm border border-white/10">
                  <div className="flex justify-center mb-4 text-blue-400">
                    {React.cloneElement(stat.icon as React.ReactElement, { className: "w-8 h-8" })}
                  </div>
                  <div className="text-3xl font-bold mb-2">{stat.value}</div>
                  <div className="text-slate-400">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </Layout>
  );
};
